import React from "react";
import { SanityFormField } from "../../models/form/SanityFormField";
import { SanityInputFieldType } from "../../models/form/SanityInputFieldType";
import Checkbox from "./Inputs/Checkbox";
import Checkboxes, { CheckboxesProps } from "./Inputs/Checkboxes";
import DatetimePicker from "./Inputs/DatetimePicker";
import Email from "./Inputs/Email";
import FileUpload from "./Inputs/FileUploadInput";
import { FormHeading } from "./Inputs/FormHeading";
import { InputContainerVariant } from "./Inputs/InputContainer";
import Number from "./Inputs/NumberInput";
import Password from "./Inputs/PasswordInput";
import PostalCode, { PostalCodeProps } from "./Inputs/PostalCode";
import RadioButtonsInverted, {
  RadioButtonsInvertedProps
} from "./Inputs/RadioButtonsInverted";
import Select, { SelectProps } from "./Inputs/Select";
import TermsAndConditionsInput from "./Inputs/TermsAndConditionsInput";
import TextArea from "./Inputs/TextArea";
import Text from "./Inputs/TextInput";

export interface InputsProps {
  inputContainerVariant?: InputContainerVariant;
  inputs: SanityFormField[];
  readonly: boolean;
}

export const Inputs = ({
  inputContainerVariant = "default",
  inputs,
  readonly
}: InputsProps) => (
  <>
    {inputs.map((input, index) => {
      if (input._type === SanityInputFieldType.FormHeading) {
        return <FormHeading key={index} heading={input.heading} />;
      } else {
        const inputProps = {
          key: input.slug.current,
          name: input.slug.current,
          inputContainerVariant,
          readonly,
          ...input
        };

        switch (input._type) {
          case SanityInputFieldType.Text:
            return <Text {...inputProps} />;
          case SanityInputFieldType.Email:
            return <Email {...inputProps} />;
          case SanityInputFieldType.Password:
            return <Password {...inputProps} />;
          case SanityInputFieldType.FileUpload:
            return <FileUpload {...inputProps} />;
          case SanityInputFieldType.Number:
            return <Number {...inputProps} />;
          case SanityInputFieldType.Dropdown:
            return <Select {...(inputProps as SelectProps)} />;
          case SanityInputFieldType.TextArea:
            return <TextArea {...inputProps} />;
          case SanityInputFieldType.Checkbox:
            return <Checkbox {...inputProps} />;
          case SanityInputFieldType.Checkboxes:
            return <Checkboxes {...(inputProps as CheckboxesProps)} />;
          case SanityInputFieldType.RadioButtons:
            return (
              <RadioButtonsInverted {...(inputProps as RadioButtonsInvertedProps)} />
            );
          case SanityInputFieldType.Datetime:
            return <DatetimePicker {...(inputProps as RadioButtonsInvertedProps)} />;
          case SanityInputFieldType.PostalCode:
            return <PostalCode {...(inputProps as PostalCodeProps)} />;
          case SanityInputFieldType.PriceCheckboxes:
            return <Checkboxes {...(inputProps as CheckboxesProps)} />;
          case SanityInputFieldType.PriceRadioButtons:
            return (
              <RadioButtonsInverted
                {...(inputProps as RadioButtonsInvertedProps)}
                validation={[{ _type: "required" }]}
                vertical
              />
            );
          case SanityInputFieldType.TermsAndConditions:
            return <TermsAndConditionsInput {...inputProps} />;

          default:
            // "input" type is "never" here, hence accessing _type through input["_type"]
            console.warn(`Unhandled input type ${input["_type"]}`);
            return null;
        }
      }
    })}
  </>
);
